import { styled } from '@mui/material';

import { COLORS } from '~/styles/colors';

export const StyledTabs = styled('div')(() => {
  return {
    backgroundColor: COLORS.white,
    borderRadius: '20px',
    padding: '4px',
    display: 'flex',
    margin: '12px auto',
    width: 'fit-content',
  };
});

export const StyledTab = styled('button')<{ $isActive?: boolean }>(({ $isActive, disabled }) => {
  let color: string = COLORS.grey400;

  if (disabled) {
    color = COLORS.grey200;
  } else if ($isActive) {
    color = COLORS.white;
  }

  return {
    backgroundColor: $isActive ? COLORS.primary : COLORS.white,
    padding: '4px 16px',
    borderRadius: '20px',
    fontSize: '16px',
    lineHeight: '21.79px',
    border: 'none',
    fontWeight: 500,
    color,
    cursor: disabled ? 'not-allowed' : 'pointer',
  };
});
